import { Row } from "antd";
import styled from "styled-components";

export const StyledRow = styled(Row)`
  margin-bottom: 32px;
  margin-top: 10px;
`;
